import React from 'react'

import AssessmentPlayer from 'src/consumer/components/AssessmentPlayer'

export default function PatientAssessmentPlayerPage() {
  return (
    <AssessmentPlayer
      embedded
      exitPath="/patient-home/assessments"
    />
  )
}
